import type { ReactNode, SVGProps } from 'react'

/**
 * De waarschuwingsdriehoek bij een falende harde controle, in Lucide-stijl (ontwerp
 * 10.2). Naast de bestaande meldingtekst en niet in plaats ervan: de kleur van de rand
 * is al niet het enige signaal (R-139, WCAG 1.4.1), en dit icoon is een tweede,
 * eveneens niet-kleurgebonden signaal, decoratief (`aria-hidden`).
 */
export function WarningIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      // Inline en niet via een CSS-klasse: dit component wordt zowel geladen waar
      // schil.css als waar alleen tokens.css staat (de configurator), en de token zelf
      // is overal aanwezig.
      style={{ width: 'var(--nwo-space-sp-4)', height: 'var(--nwo-space-sp-4)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  )
}
